<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="name"
    track-by="id"
    :options="options"
    :searchable="false"
    :disabled="!editable"
    :allow-empty="false"
    deselect-label="">
    <template slot="singleLabel"
              slot-scope="props">
      <div class="option__desc"
           :style="'background-color:'+props.option.value">
        <span class="option__image">
          &nbsp;
        </span>
      </div>
    </template>
    <template slot="option"
              slot-scope="props">
      <div class="option__desc"
           :style="'background-color:'+props.option.value">
        <span class="option__image">
          &nbsp;
        </span>
      </div>
    </template>
    <template #placeholder>
      {{ $t('common.SelectOne') }}
    </template>
  </v-multiselect>
</template>
<script>
import Colors from '@utils/doctorColors';

export default {
  name: 'ColorInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      options: Colors
    };
  },
  computed: {
    fieldModelValue: {
      get() {
        if (!this.value) this.$emit('input', 1);
        return (
          this.options.filter((x) => x.id === this.value)
          || this.options.filter((x) => x.id === 1)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
